import React from 'react';

const etiqueta = (k) => k.replace(/_/g, ' ');
const esEscalar = (v) => v === null || ['string', 'number', 'boolean'].includes(typeof v);
const valor = (v) => (v === null ? '—' : typeof v === 'boolean' ? (v ? 'sí' : 'no') : typeof v === 'number' ? v.toLocaleString('es-AR') : v);

// Resultado de una migración B–F: números arriba y el detalle (ejemplos, cambios, backups) desplegable.
export const MigracionResultadoGenerico = ({ r }) => {
  const entradas = Object.entries(r || {}).filter(([k]) => k !== 'ejecutar');
  const escalares = entradas.filter(([, v]) => esEscalar(v));
  const detalle = entradas.filter(([, v]) => !esEscalar(v));
  return (
    <div className="space-y-3" data-testid="migracion-resultado">
      <p className={`text-xs font-semibold ${r?.ejecutar ? 'text-red-700' : 'text-slate-500'}`}>
        {r?.ejecutar ? 'Resultado de la ejecución' : 'Vista previa (no se cambió nada)'}
      </p>
      <div className="grid grid-cols-1 gap-y-1 max-w-xl">
        {escalares.map(([k, v]) => (
          <div key={k} className="flex justify-between gap-3 border-b border-slate-100 py-1 text-sm">
            <span className="text-slate-600">{etiqueta(k)}</span>
            <span className="font-mono text-slate-900 tabular-nums shrink-0" data-testid={`migracion-valor-${k}`}>{valor(v)}</span>
          </div>
        ))}
      </div>
      {detalle.map(([k, v]) => (
        <details key={k} className="rounded-md border border-slate-200" open={k === 'cambios' || k === 'backups'}>
          <summary className="cursor-pointer px-3 py-1.5 text-sm font-medium text-slate-700">{etiqueta(k)}</summary>
          <pre className="max-h-64 overflow-auto bg-slate-50 px-3 py-2 text-[11px] text-slate-700 whitespace-pre-wrap break-all">{JSON.stringify(v, null, 2)}</pre>
        </details>
      ))}
    </div>
  );
};
